export default class ReadMore{
    constructor($elt) {
        this.$elt = $elt;
        this.$container = this.$elt.firstChild;
        this.isCollapse = false;
        this.maxHeight = 200;
        this.$btn = null;
        this._init();
        this._addEvents();
    }

    _init() {
        this._onResize();
    }

    _addEvents() {
        window.addEventListener('resize', this._onResize.bind(this));
    }

    _onResize() {
        // si la hauteur du bloc depasse le maxHeight on initilize
        this._removeReadMore();
        if (this.$container.offsetHeight > this.maxHeight) {
            this._addReadMore();
        }
    }

    _addReadMore() {
        // ajout du style au bloc
        this.$elt.classList.add('read-more','is-active', 'is-collapse');
        this.$container.style.setProperty('--original-height', this.$elt.offsetHeight + 'px');
        this.$container.style.height = this.maxHeight + 'px';

        // ajout du bouton pour gerer l'ouverture et fermeture du bloc
        this.$btn = document.createElement('button');
        this.$btn.textContent = "Lire plus";
        this.$btn.classList.add('read-more-btn', 'bricks-button');
        this.$btn.addEventListener('click', this._toggleContent.bind(this));
        this.$elt.appendChild(this.$btn);

        this.isCollapse = true;
    }

    _toggleContent() {
        if (this.isCollapse) {
            this.$elt.classList.remove('is-collapse');
            this.$btn.textContent = "Lire moins";
            this.isCollapse = false;
        } else {
            this.$elt.classList.add('is-collapse');
            this.$btn.textContent = "Lire plus";
            this.isCollapse = true;
        }
    }

    _removeReadMore() {
        if (this.$btn) {
            this.$btn.removeEventListener('click', this._toggleContent.bind(this));
            this.$btn.remove();
        }
        this.$elt.classList.remove('read-more','is-active', 'is-collapse');
        this.$container.style.height = 'auto';
        this.isCollapse = false;
    }
}